<template>
    <div class="crm-main-cont">
        <div>
            <a-spin tip="Loading..." :spinning="spinning">
                <div class="search-box">
                    <a-form :form="formSearch" layout="inline">
                        <a-form-item label="产品名称:">
                            <a-input v-decorator="['proname1']"/>
                        </a-form-item>
                        <a-form-item label="服务机构:">
                            <a-input v-decorator="['servebank']"/>
                        </a-form-item>
                        <a-form-item
                            label="申请日期"
                        >
                          <a-range-picker v-decorator="['times']" />
                        </a-form-item>
                    </a-form>
                </div>
                <div class="btns-group">
                    <a-button
                            @click="searchConfirm"
                            type="primary"
                            style="margin-top: 26px"
                    >搜索
                    </a-button
                    >
                    <a-button @click="backConfirm">重置</a-button>
                    <a-button
                            type="primary"
                            @click="financingDirectional"
                            :style="{ marginRight: '20px' }"
                    >
                        定向模式
                    </a-button>
                    <a-button type="primary" @click="financingSnatch">
                        抢单模式
                    </a-button>
                </div>

                <a-table
                        bordered
                        rowKey="id"
                        :pagination="pagination"
                        :dataSource="dataSource"
                        @change="change"
                        :columns="columns"
                        :scroll="{x:1500}"
                >
                    <template slot="commitAmout" slot-scope="text">
                        <span v-if="text != null">{{
                            (parseFloat(text)/10000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span>
                    </template>
                    <template slot="loanAmout" slot-scope="text">
                        <span v-if="text != null">{{
                            String((parseFloat(text)/10000).toFixed(2)).replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                            )
                        }}</span>
                    </template>
                    <template slot="interestRate" slot-scope="text">
                        <span v-if="text != null">{{
                            Number(text).toFixed(4)
                        }}</span>
                    </template>
                    <template slot="operation" slot-scope="text, record">
                        <a-space>
                            <span v-if="record.type == 1 && record.status == 0"><a @click="showOffers(record)">查看报价</a></span>
                            <span><a @click="showOffersDetail(record)">详情</a></span>
                        </a-space>
                    </template>

                    <template slot="status" slot-scope="text">
                        <span v-if="text === 0"><a-tag color="orange">待受理</a-tag></span>
                        <span v-if="text === 1"><a-tag color="green">待授信</a-tag></span>
                        <span v-if="text === 2"><a-tag color="grey">拒贷</a-tag></span>
                        <span v-if="text === 3"><a-tag color="cyan">已授信</a-tag></span>
                        <span v-if="text === 4"><a-tag color="blue">已结清</a-tag></span>
                        <span v-if="text === 5"><a-tag color="grey">拒贷</a-tag></span>
                    </template>
                </a-table>
            </a-spin>


            <a-drawer
                :title="showItem.financingRequirementsCode==null?'查看详情':'查看详情,省统一需求编码：'+showItem.financingRequirementsCode"
                    :width="650"
                    @close="onCloseDetails"
                    :visible="visibleDetails"
            >
                <a-descriptions title="主体信息" :column="2" bordered>
                    <a-descriptions-item label="主体名称">
                        {{ showItem.companyName }}
                    </a-descriptions-item>
                    <a-descriptions-item label="统一社会信用代码">
                        {{ showItem.socialCreditUnicode }}
                    </a-descriptions-item>
                    <a-descriptions-item label="法定代表人" v-if="showItem.zttype===2">
                        {{ showItem.frdb }}
                    </a-descriptions-item>
                    <a-descriptions-item label="所属行业" v-if="showItem.type===1">
                        {{ showItem.industry }}
                    </a-descriptions-item>
                    <a-descriptions-item label="主体所在省市区" v-if="showItem.type===1">
                        {{ showItem.area }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="showItem.zttype===2?'经营地址':'联系地址'">
                        {{ showItem.address }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-descriptions style="margin-top: 20px" title="融资信息" :column="2" bordered>
                    <a-descriptions-item label="申请产品">
                        {{ showItem.productName==null?'-':showItem.productName }}
                    </a-descriptions-item>
                    <a-descriptions-item label="申贷金额">
                        {{
                        String(showItem.commitAmout).replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                        )
                        }}元
                    </a-descriptions-item>
                    <a-descriptions-item label="经办人">
                        {{ showItem.contact==undefined||showItem.contact==''?'-':showItem.contact }}
                    </a-descriptions-item>
                    <a-descriptions-item label="经办人身份证号码" v-if="showItem.type===0">
                        {{ showItem.contactIdcard }}
                    </a-descriptions-item>
                    <a-descriptions-item :label="showItem.type===1?'手机号码':'经办人手机号码'">
                        {{ showItem.contactMobile }}
                    </a-descriptions-item>
                    <a-descriptions-item label="是否首贷户">
                      {{ showItem.isFirstUser===0?'是':'否' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="申请日期">
                        {{ showItem.createTime==null?'-':showItem.createTime }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-descriptions style="margin-top: 20px" title="融资期望信息" :column="2" bordered>
                    <a-descriptions-item label="期望金额">
                        {{
                        String(showItem.commitAmout).replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                        )
                        }}元
                    </a-descriptions-item>
                    <a-descriptions-item label="期望的年利率">
                        {{ showItem.interestRate }}%
                    </a-descriptions-item>
                    <a-descriptions-item label="期望的融资期限">
                        {{ showItem.deadline }}个月
                    </a-descriptions-item>
                    <a-descriptions-item v-if="showItem.type===1" label="期望贷款到账时间">
                        {{ showItem.loanArrival }}天
                    </a-descriptions-item>
                  <a-descriptions-item label="贷款用途">
                    {{ showItem.yt }}
                  </a-descriptions-item>
                </a-descriptions>
                <a-descriptions style="margin-top: 20px" title="企业信息" :column="2" bordered>
                    <a-descriptions-item label="上年度纳税金额">
                        {{ showItem.taxAmountOfLastYear==null?'-':showItem.taxAmountOfLastYear }}
                    </a-descriptions-item>
                    <a-descriptions-item label="企业盈亏状况">
                        {{ showItem.profitOrLossStatus==null?'-':showItem.profitOrLossStatus }}
                    </a-descriptions-item>
                    <a-descriptions-item label="上年度开票营业收入">
                        {{ showItem.businessIncome==null?'-':showItem.businessIncome }}
                    </a-descriptions-item>
                    <a-descriptions-item label="纳税等级">
                        {{ showItem.taxGrade==null?'-':showItem.taxGrade }}
                    </a-descriptions-item>
                    <a-descriptions-item label="是否有抵押物">
                        {{ showItem.isCollateral==null?'-':showItem.isCollateral }}
                    </a-descriptions-item>
                    <a-descriptions-item label="开户行">
                        {{ showItem.bankOfDeposit==null?'-':showItem.bankOfDeposit }}
                    </a-descriptions-item>
                    <a-descriptions-item label="当前贷款余额">
                        {{ showItem.currentLoanBalance==null?'-':String(showItem.currentLoanBalance).replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                        )
                        +'元'}}
                    </a-descriptions-item>
                    <!--                <a-descriptions-item label="贷款到账时间">-->
                    <!--                    {{ showItem.loanArrival }}天-->
                    <!--                </a-descriptions-item>-->
                    <a-descriptions-item label="之前贷款机构">
                        {{ showItem.previousLendingInstitutions==null?'-':showItem.previousLendingInstitutions }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-descriptions style="margin-top: 20px" title="授信信息" :column="2" bordered>
                    <a-descriptions-item label="授信金额">
              <span v-if="showItem.loanAmout != null">{{String(showItem.loanAmout).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}元</span>
                        <span v-if="showItem.loanAmout == null">-</span>
                    </a-descriptions-item>
                    <a-descriptions-item label="授信利率">
              <span v-if="showItem.interestRate != null">{{Number(showItem.interestRate).toFixed(4)}}%</span>
                        <span v-if="showItem.interestRate == null">-</span>
                    </a-descriptions-item>
                    <a-descriptions-item label="授信日期">
              <span v-if="showItem.loanTime != null">{{
                  showItem.loanTime
                }}</span>
                        <span v-if="showItem.loanTime == null">-</span>
                    </a-descriptions-item>
                    <a-descriptions-item label="授信期限">
              <span v-if="showItem.deadline != null">{{
                  showItem.deadline
                }}个月</span>
                        <span v-if="showItem.deadline == null">-</span>
                    </a-descriptions-item>
                </a-descriptions>
                <a-descriptions title="受理机构信息" :column="2" bordered v-if="showItem.yxdwUserId!=null"
                                style="margin-top: 20px">
                    <a-descriptions-item label="受理人">
                        {{account.name==null?'-':account.name}}
                    </a-descriptions-item>
                    <a-descriptions-item label="受理人手机">
                        {{account.mobile==null?'-':account.mobile}}
                    </a-descriptions-item>
                    <a-descriptions-item label="受理机构">
                        {{account.department}}{{account.nickName}}
                    </a-descriptions-item>
                </a-descriptions>

            </a-drawer>

            <a-drawer
                    :title="title"
                    :width="650"
                    @close="onClose"
                    :visible="visible"
            >

                <a-steps :current="current">
                    <a-step v-for="(item,index) in stepList"
                            :key="item.title"
                            :status="item.status"
                            :title="item.title">
                        <a-icon slot="icon" :type="item.iconType"/>
                    </a-step>
                </a-steps>
                <a-form style="margin-top: 20px"
                        :form="formDirectional2"
                        layout="vertical"
                >
                    <a-row :gutter="16" v-show="current === 0">
                        <a-col :span="12">
                            <a-form-item label="主体名称">
                                <a-select
                                        v-decorator="[
                                        'companyName',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写主体名称!'
                                                }
                                            ]
                                        }
                                    ]"
                                        @change="handleCompanyChange"
                                >
                                    <a-select-option
                                            v-for="org in this.companyNames"
                                            :value="org"
                                            :key="org.id"
                                    >
                                        {{ org }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="统一社会信用代码">
                                <a-input
                                        v-decorator="['socialCreditUnicode', {}]"
                                        disabled
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" v-show="current === 0">
                        <a-col :span="12" v-if="this.$store.state.account.roleType==7">
                            <a-form-item label="法人代表">
                                <a-input
                                        v-decorator="[
                                        'frdb',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写法人代表'
                                                }
                                            ]
                                        }
                                    ]"
                                        disabled
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="所属行业">
                                <a-select
                                        placeholder="请选择您的所属行业"
                                        v-decorator="[
                                        'industry',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择您的所属行业'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-select-option v-for="(item,index) in industryList" :key="item.id"
                                                     :value="item.param">
                                        {{item.desc}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" v-show="current === 0">
                        <a-col :span="12">
                            <a-form-item :label="title=='融资（抢单）'?'经营地址':this.$store.state.account.roleType==7?'经营地址':'联系地址'">
                                <a-input
                                        placeholder="请填写您的经营地址"
                                        v-decorator="[
                                        'address',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写您的经营地址'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="主体所在省市区">
                                <a-cascader
                                        v-decorator="['area', {
                                            rules:[
                                                {
                                                    required: true,
                                                    message:'请选择主体所在区域'
                                                },
                                            ]
                                        }]"
                                        :options="changshaRegion"
                                        placeholder="请选择主体所在区域"/>
                                <a-input
                                        v-decorator="['companyId', {}]"
                                        hidden
                                />
                                <a-input
                                        v-decorator="['frdb', {}]"
                                        hidden
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" v-show="current === 0">
                        <a-col :span="12">
                            <a-form-item label="经办人">
                                <a-select  @change="managerNameChange"
                                          v-decorator="[
                                        'contact',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择经办人'
                                                }
                                            ]
                                        }
                                    ]"
                                          placeholder="请选择经办人"
                                          :dropdownMatchSelectWidth="false"
                                >
                                    <a-select-option
                                            :key="manager.id"
                                            v-for="manager in this.contactList"
                                            :values="manager.managerName"
                                    >
                                        {{ manager.managerName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" >
                            <a-form-item label="经办人身份证号码">
                                <a-input disabled
                                         v-decorator="[
                                        'contactIdcard',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写经办人身份证号码'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item :label="'经办人手机号码'">
                                <a-input
                                        :disabled="true"
                                        placeholder="请填写您的手机号码"
                                        v-decorator="[
                                        'contactMobile',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写您的手机号码'
                                                },
                                                { validator: validatePhone }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                          <a-form-item label="是否首贷户">
                            <a-select
                                placeholder="请选择是否首贷户"
                                v-decorator="[
                                          'isFirstUser',
                                          {
                                              rules: [
                                                  {
                                                      required: true,
                                                      message: '请选择是否首贷户'
                                                  }
                                              ]
                                          }
                                      ]"
                            >
                              <a-select-option :value="0">
                                是
                              </a-select-option>
                              <a-select-option :value="1">
                                否
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" v-show="current === 1">
                        <a-col :span="12" v-if="productShow && title=='融资（定向）'">
                            <a-form-item label="对应的金融产品" ref="genderRef">
                                <a-select
                                        ref="genderRef"
                                        show-search
                                        placeholder="请选择对应的金融产品"
                                        option-filter-prop="children"
                                        :filter-option="filterOption"
                                        @change="handleSelectChange"
                                        v-decorator="[
                                        'gender',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择对应的金融产品'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-select-option
                                            :key="org.indexId"
                                            v-for="org in options"
                                            :value="org.indexId "
                                    >
                                        {{ org.name }}({{org.logindept}})
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-if="deptShow && title=='融资（定向）'">
                            <a-form-item label="所属金融机构" ref="logindeptRef">
                                <template>
                                    <a-input
                                            placeholder="请先选择对应的金融产品"
                                            ref="logindeptRef"
                                            disabled
                                            v-decorator="[
                                            'logindept',
                                            {
                                                rules: [
                                                    {
                                                        required: true
                                                    }
                                                ]
                                            }
                                        ]"
                                    />
                                </template>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-if="deptNameShow && title=='融资（定向）'">
                            <a-form-item label="机构名称（请根据区域选择）" ref="userIdRef">
                                <template>
                                    <a-select
                                            v-decorator="[
                                        'userId',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择机构名称'
                                                }
                                            ]
                                        }
                                    ]"
                                            placeholder="请先选择对应的金融产品"
                                            :dropdownMatchSelectWidth="false"
                                    >
                                        <a-select-option
                                                :key="org.id"
                                                v-for="org in regionMark"
                                                :value="org.id"
                                        >
                                            {{ org.dept }}({{ org.address }})
                                        </a-select-option>
                                    </a-select>
                                </template>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item :label="title=='融资（定向）'?'贷款金额':'期望的融资金额'">
                                <a-input
                                        :initialValue="0"
                                        v-decorator="[
                                        'commitAmout',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:`请填写您${title=='融资（定向）'?'':'期望'}的${title=='融资（定向）'?'贷款':'期望'}金额`
                                                },
                                                // { validator: validatePhone }
                                            ]
                                        }
                                    ]"
                                        suffix="万元"
                                        style="width: 100%"
                                        :placeholder="title=='融资（定向）'?'请填写您的贷款金额':'请填写您期望的融资金额'"
                                        @input="transform($event)"
                                />
                                <span v-if="chinesePriceVisable">{{
                                    chinesePrice
                                }}</span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-if="title=='融资（抢单）'">
                            <a-form-item label="期望的年利率">
                                <a-input
                                        v-decorator="[
                                        'interestRate',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请填写您期望的年利率'
                                                },
                                            ]
                                        }
                                    ]"
                                        suffix="%"
                                        style="width: 100%"
                                        placeholder="请填写您期望的年利率"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" v-show="current === 1">
                        <a-col :span="12">
                            <a-form-item :label="title=='融资（定向）'?'贷款期限':'期望融资期限'">
                                <a-input
                                        v-decorator="[
                                        'deadline',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:`请填写您${title=='融资（定向）'?'贷款':'期望融资'}期限`
                                                },
                                                { validator: validateData }
                                            ]
                                        }
                                    ]"
                                        suffix="个月"
                                        style="width: 100%"
                                        :placeholder="title=='融资（定向）'?'请填写您贷款期限':'请填写您期望融资期限'"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="期望贷款到账时间">
                                <a-input
                                        v-decorator="[
                                        'loanArrival',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请填写您期望贷款到账时间'
                                                },
                                                { validator: validateData }
                                            ]
                                        }
                                    ]"
                                        suffix="天"
                                        style="width: 100%"
                                        placeholder="请填写您期望贷款到账时间"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                  <a-row :gutter="16" v-show="current === 1">
                    <a-col :span="12">
                      <a-form-item label="贷款用途">
                        <a-select
                            v-decorator="[
                                        'yt',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择贷款用途'
                                                }
                                            ]
                                        }
                                    ]"
                            placeholder="请选择贷款用途"
                            :dropdownMatchSelectWidth="false"
                        >
                          <a-select-option value="经营贷款">经营贷款</a-select-option>
                          <a-select-option value="进货备货">进货备货</a-select-option>
                          <a-select-option value="投资新店">投资新店</a-select-option>
                          <a-select-option value="建设厂房">建设厂房</a-select-option>
                          <a-select-option value="生产经营">生产经营</a-select-option>
                          <a-select-option value="其他">其他</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                    <a-row :gutter="16" v-show="current === 2">
                        <a-col :span="12">
                            <a-form-item label="上年度纳税金额">
                                <a-select
                                        v-decorator="[
                                        'taxAmountOfLastYear',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择上年度纳税金额'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请选择上年度纳税金额"
                                >
                                    <a-select-option v-for="item in taxList"
                                                     :key="item"
                                    >
                                        {{item}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="企业盈亏状况">
                                <a-select
                                        v-decorator="[
                                        'profitOrLossStatus',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择企业盈亏状况'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请选择企业盈亏状况"
                                >
                                    <a-select-option value="亏损">
                                        亏损
                                    </a-select-option>
                                    <a-select-option value="盈利">
                                        盈利
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="上年度开票营业收入">
                                <a-select
                                        v-decorator="[
                                        'businessIncome',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择上年度开票营业收入'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请选择上年度开票营业收入"
                                >
                                    <a-select-option v-for="item in businessIncomeList"
                                                     :key="item"
                                    >
                                        {{item}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="纳税等级">
                                <a-select
                                        v-decorator="[
                                        'taxGrade',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择纳税等级'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请选择纳税等级"
                                >
                                    <a-select-option v-for="item in taxGradeList"
                                                     :key="item"
                                    >
                                        {{item}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="是否有抵押物">
                                <a-select
                                        v-decorator="[
                                        'isCollateral',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请选择是否有抵押物'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请选择是否有抵押物"
                                >
                                    <a-select-option value="无">
                                        无
                                    </a-select-option>
                                    <a-select-option value="有">
                                        有
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="开户行">
                                <a-input
                                        v-decorator="[
                                        'bankOfDeposit',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:'请填写您的开户行'
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请填写您的开户行"
                                >
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="当前贷款余额">
                                <a-input
                                        :initialValue="0"
                                        v-decorator="[
                                        'currentLoanBalance',
                                        {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ]
                                        }
                                    ]"
                                        suffix="万元"
                                        @input="transform2($event)"
                                        placeholder="请填写您当前贷款余额"
                                />
                                <span v-if="chinesePriceVisable2">{{
                                    chinesePrice2
                                }}</span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="之前贷款机构">
                                <a-input
                                        v-decorator="[
                                        'previousLendingInstitutions',
                                        {
                                            rules: [
                                                {
                                                    required: false,
                                                },
                                            ]
                                        }
                                    ]"
                                        style="width: 100%"
                                        placeholder="请填写您之前贷款机构"
                                >
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item>
                                <a-checkbox
                                        v-model="toggle"
                                        v-bind:true-value="a"
                                        v-bind:false-value="b"
                                >
                                    <span style="color: #f5222d">*</span><span>同意金融机构查看信用报告</span>
                                </a-checkbox>
                                <a @click="down2">查看授权同意书</a>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>

                <!--定向-->
                <a-form :form="formDirectional" layout="vertical" v-show="false">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="主体名称">
                                <a-select
                                        v-decorator="[
                                        'companyName',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写顺序号!'
                                                }
                                            ]
                                        }
                                    ]"
                                        @change="handleCompanyChange"
                                >
                                    <a-select-option
                                            v-for="org in this.companyNames"
                                            :value="org"
                                            :key="org.id"
                                    >
                                        {{ org }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="统一社会信用代码">
                                <a-input
                                        v-decorator="['socialCreditUnicode', {}]"
                                        disabled
                                />

                                <a-input
                                        v-decorator="['companyId', {}]"
                                        hidden
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-if="this.$store.state.account.roleType==7">
                            <a-form-item label="法人代表">
                                <a-input
                                        v-decorator="[
                                        'frdb',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写法人代表'
                                                }
                                            ]
                                        }
                                    ]"
                                        disabled
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item :label="this.$store.state.account.roleType==7?'经营地址':'联系地址'">
                                <a-input
                                        v-decorator="[
                                        'address',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写地址'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16">
                        <a-col :span="12" v-show="productShow">
                            <a-form-item label="对应的金融产品" ref="genderRef">
                                <a-select
                                        ref="genderRef"
                                        show-search
                                        placeholder="请选择对应的金融产品"
                                        option-filter-prop="children"
                                        :filter-option="filterOption"
                                        @change="handleSelectChange"
                                        v-decorator="[
                                        'gender',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择对应的金融产品'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-select-option
                                            :key="org.indexId"
                                            v-for="org in options"
                                            :value="org.indexId "
                                    >
                                        {{ org.name }}({{org.logindept}})
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-show="deptShow">
                            <a-form-item label="所属金融机构" ref="logindeptRef">
                                <template>
                                    <a-input
                                            ref="logindeptRef"
                                            disabled
                                            v-decorator="[
                                            'logindept',
                                            {
                                                rules: [
                                                    {
                                                        required: true
                                                    }
                                                ]
                                            }
                                        ]"
                                    />
                                </template>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" v-show="deptNameShow">
                            <a-form-item label="机构名称（请根据区域选择）" ref="userIdRef">
                                <template>
                                    <a-select
                                            v-decorator="[
                                        'userId',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择机构名称'
                                                }
                                            ]
                                        }
                                    ]"
                                            placeholder="请选择机构名称"
                                            :dropdownMatchSelectWidth="false"
                                    >
                                        <a-select-option
                                                :key="org.id"
                                                v-for="org in regionMark"
                                                :value="org.id"
                                        >
                                            {{ org.dept }}({{ org.address }})
                                        </a-select-option>
                                    </a-select>
                                </template>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item
                                    label="贷款金额(单位：万元，币种：人民币）"
                            >
                                <a-input
                                        :initialValue="0"
                                        v-decorator="[
                                        'commitAmout',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写贷款金额（元）'
                                                }
                                            ]
                                        }
                                    ]"
                                        style="text-align: right"
                                        @input="transform($event)"
                                />
                                <span v-if="chinesePriceVisable">{{
                                    chinesePrice
                                }}</span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="贷款期限（月）">
                                <a-input-number
                                        v-decorator="[
                                        'deadline',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写贷款期限'
                                                },
                                                { validator: validateData }
                                            ]
                                        }
                                    ]"
                                        style="width: 100%;"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="经办人">
                                <!--<a-input
                                    v-decorator="[
                                        'contact',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请填写经办人'
                                                }
                                            ]
                                        }
                                    ]"
                                />-->
                                <a-select @change="managerNameChange"
                                          v-decorator="[
                                        'contact',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择经办人'
                                                }
                                            ]
                                        }
                                    ]"
                                          placeholder="请选择经办人"
                                          :dropdownMatchSelectWidth="false"
                                >
                                    <a-select-option
                                            :key="manager.id"
                                            v-for="manager in this.contactList"
                                            :values="manager.managerName"
                                    >
                                        {{ manager.managerName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="经办人身份证号码">
                                <a-input disabled
                                         v-decorator="[
                                        'contactIdcard',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写经办人身份证号码'
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="经办人手机号码">
                                <a-input disabled
                                         v-decorator="[
                                        'contactMobile',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        '请填写经办人手机号码'
                                                },
                                                { validator: validatePhone }
                                            ]
                                        }
                                    ]"
                                         style="width:160px;margin-right: 5px"
                                />
                                <!--                                <a-button class="code" :disabled="disabled" @click="sendcode(1)">
                                                                    <span style="font-size: 14px">{{buttontext}}</span>
                                                                </a-button>-->
                            </a-form-item>

                        </a-col>
                        <!--                        <a-col :span="12">
                                                    <a-form-item label="手机验证码">
                                                        <a-input
                                                                v-decorator="[
                                                                'code',
                                                                {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                '请填写验证码'
                                                                        }
                                                                    ]
                                                                }
                                                            ]"
                                                        />
                                                    </a-form-item>
                                                </a-col>-->
                    </a-row>
                    <a-row :gutter="16">
                        <a-col :span="24">
                            <a-form-item>
                                <a-checkbox
                                        v-model="toggle"
                                        v-bind:true-value="a"
                                        v-bind:false-value="b"
                                >
                                    <span style="color: #f5222d">*</span><span>同意金融机构查看信用报告</span>
                                </a-checkbox>
                                <a @click="down2">查看授权同意书</a>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <div
                        :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right'
                    }"
                >
                    <a-button @click="directionalConfirm" type="primary"
                              :loading="subbtnLoading"
                    >提交
                    </a-button
                    >
                </div>
                <div v-show="title=='融资（抢单）'">
                  <a-icon type="notification" style="color: #1890ff;font-size: 24px"/><span style="font-size: 16px;margin-left: 10px;">融资助手推荐:</span>
                  <a-row :span="24" :gutter="16">
                    <a-col :span="12" v-for="item in productOptions">
                      <a-card  :title="item.proname" @click="listClick(item.id)">
                        贷款额度:{{ item.loanMin }}~{{ item.loanMax }}万元<br/>
                        贷款期限:{{ item.loanDeadlineMin }}~{{ item.loanDeadlineMax }}个月<br/>
                        年利率（单利）:
                        <span v-if="item.rateMin == 0 && item.rateMax != 0">
                          不高于{{ item.rateMax }}%
                        </span>
                        <span v-else-if="item.rateMin != 0 && item.rateMax == 0">
                          {{ item.rateMin }}%起
                        </span>
                        <span v-else-if="item.rateMin == 0 && item.rateMax == 0">
                          面议
                        </span>
                        <span v-else>
                          {{ item.rateMin }}~{{ item.rateMax }}%
                        </span>
                        <br/>
                        审批时间:
                        <span v-if="item.approvalMin ==0 && item.approvalMax == 0">
                          秒申秒贷
                        </span>
                        <span v-else>
                          {{ item.approvalMin }}~{{ item.approvalMax }}个工作日
                        </span>
                      </a-card>
                    </a-col>
                  </a-row>

                </div>
                <!-- v-if="title == '融资（抢单）'" -->
                <div
                        :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right'
                    }"
                >
                    <a-button ghost v-if="current > 0" type="primary" style="margin-left: 8px;float: left"
                              @click="previousStep">
                        上一步
                    </a-button>
                    <a-button
                            v-if="current == stepList.length - 1"
                            :loading="subbtnLoading"
                            type="primary" @click="directionalConfirm"
                    >
                        发布融资需求
                    </a-button>
                    <a-button v-if="current < stepList.length - 1" type="primary" @click="nextStep">
                        下一步
                    </a-button>
                </div>
            </a-drawer>


            <a-spin tip="Loading..." :spinning="spinning">
                <a-modal
                        v-model="hide"
                        title="金融产品"
                        onOk="handleOk"
                        width="800px"
                >
                    <template slot="footer">
                        <a-button key="submit" type="primary" @click="handleOk">
                            确定
                        </a-button>
                    </template>
                    <a-descriptions :column="2" bordered>
                        <a-descriptions-item label="产品名称">
                            {{ showItem.proname }}
                        </a-descriptions-item>
                        <a-descriptions-item label="适用对象">
                            {{ showItem.type }}
                        </a-descriptions-item>
                        <a-descriptions-item label="担保方式">
                            {{ showItem.guarantee }}
                        </a-descriptions-item>
                        <a-descriptions-item label="审批模式">
                            {{ showItem.approval_model }}
                        </a-descriptions-item>
                        <a-descriptions-item label="是否政策性产品">
                            {{ showItem.policy }}
                        </a-descriptions-item>
                        <a-descriptions-item label="产品类型">
                            {{ showItem.product_type }}
                        </a-descriptions-item>
                        <a-descriptions-item label="贷款额度">
                            {{ showItem.loanMin }}~{{ showItem.loanMax }}万元
                        </a-descriptions-item>
                        <a-descriptions-item label="贷款期限">
                            {{ showItem.loanDeadlineMin }}~{{ showItem.loanDeadlineMax }}个月
                        </a-descriptions-item>
                        <a-descriptions-item label="年利率（单利）">
                            <div v-if="showItem.rateMin == 0 && showItem.rateMax != 0">
                                不高于{{ showItem.rateMax }}%
                            </div>
                            <div v-else-if="showItem.rateMin != 0 && showItem.rateMax == 0">
                                {{ showItem.rateMin }}%起
                            </div>
                            <div v-else-if="showItem.rateMin == 0 && showItem.rateMax == 0">
                                面议
                            </div>
                            <div v-else>
                                {{ showItem.rateMin }}~{{ showItem.rateMax }}%
                            </div>
                        </a-descriptions-item>
                        <a-descriptions-item label="服务区域">
                            {{ showItem.region }}
                        </a-descriptions-item>
                        <a-descriptions-item label="还款方式">
                            {{ showItem.repayment_mode }}
                        </a-descriptions-item>
                        <a-descriptions-item label="审批时间">
                            <div v-if="showItem.approvalMin ==0 && showItem.approvalMax == 0">
                                秒申秒贷
                            </div>
                            <div v-else>
                                {{ showItem.approvalMin }}~{{ showItem.approvalMax }}个工作日
                            </div>
                        </a-descriptions-item>
                        <a-descriptions-item label="所属银行">
                            {{ showItem.logindept }}
                        </a-descriptions-item>
                        <a-descriptions-item label="产品简介" :span="2">
                            <p v-html="showItem.introduction"></p>
                        </a-descriptions-item>
                        <a-descriptions-item label="准入条件" :span="2">
                            <p v-html="showItem.access_conditions"></p>
                        </a-descriptions-item>
                        <a-descriptions-item label="产品特点" :span="2">
                            <p v-html="showItem.product_feature"></p>
                        </a-descriptions-item>
                        <a-descriptions-item label="适用群体" :span="2">
                            <p v-html="showItem.apply_group"></p>
                        </a-descriptions-item>
                        <a-descriptions-item label="相关费用" :span="2">
                            <p v-html="showItem.cost"></p>
                        </a-descriptions-item>
                    </a-descriptions>

                </a-modal>
            </a-spin>

            <a-spin tip="Loading..." :spinning="spinning">
                <a-modal
                        v-model="hide2"
                        title="报价清单"
                        onOk="handleOk"
                        width="1000px"
                >
                    <a-table
                            bordered
                            rowKey="id"
                            :pagination="paginationOffer"
                            :dataSource="dataSourceOffer"
                            @change="change2"
                            :columns="columnsOffer"
                    >
                        <template slot="fkje" slot-scope="text">
                            <span v-if="text != null">{{
                                String((parseFloat(text)/10000).toFixed(2)).replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                )
                            }}</span>
                        </template>
                        <template slot="yname" slot-scope="text,record">
                            {{text}}
                            <span v-if="record.userDept != null">-{{record.userDept }}</span>
                        </template>
                        <template slot="guarantee" slot-scope="text">
                            <span v-if="text == 0">不需要担保</span>
                            <span v-if="text == 1">需要担保</span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <span>
                                <a-popconfirm
                                        title="确定使用该方案?"
                                        @confirm="getOffers(record)"
                                        @cancel="cancelOffer"
                                        okText="确定"
                                        cancelText="取消"
                                >
                                    <a href="#">申请贷款</a>
                                </a-popconfirm>
                            </span>
                        </template>
                    </a-table>
                    <template slot="footer">
                        <a-button
                                key="submit"
                                type="primary"
                                @click="handleOk2"
                        >
                            确定
                        </a-button>
                    </template>
                </a-modal>
                <!--<a-modal v-model="modelState" footer="" class="certification" width="1000px">
                    <div v-html="authorization">

                    </div>
                </a-modal>-->
            </a-spin>


        </div>

        <a-modal
                v-model="modelState2" :closable="true" footer=""
                width="1000px" @cancel="afterClose"
        >
            <div style="display: flex; flex-direction: column; text-align: left;margin-bottom: 60px;">
                <div id="title" style="margin-bottom: 5px;">
                    <h1 style="text-align: center;margin: 0px auto">
                        <p style="font-size: 24px;display: inline-block;">
                            {{titleName}}
                        </p>
                    </h1>
                </div>
                <div style="width: 800px;margin-left: auto;margin-right: auto;">
                    <p>
                        <span v-html="editContent"></span>
                    </p>
                </div>
            </div>
        </a-modal>
      <a-modal
          v-model="showOperatorCode"
          :closable="true"
          width="400px"
          @cancel="onClose"
          title="短信验证"
      >
        <template #footer>
          <div >
            <a-space>
              <a-button @click="onClose">取消</a-button>
              <a-button @click="directionalConfirm" type="primary">提交</a-button>
            </a-space>
          </div>
        </template>
        <div
            style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    margin-bottom: 60px;
                "
        >
          <p style="line-height: 30px">请输入手机验证码:</p>
          <a-input v-model:value="operatorCode" placeholder="请输入手机验证码" />
        </div>
      </a-modal>
    </div>

</template>

<script>
import axios from "axios";
import {
  myFinancing,
  mySelect,
  priceToChinese,
  mySelectmes,
  addFinancing,
  uoloadFilesq,
  offerList,
  getOffer,
  getFzjg, numberToChines, getRecommended,financingRequirementsCode
} from "../../api/http";
import {getCompanyList, getSqtys, findOnProId} from "@/api/finance/finance";
import {getEnablePowerOfAttorney} from "@/api/powerOfAttorne/powerOfAttorne";

import {getManagerList, getManagerLists} from "@/api/manager/manager";
import {getListByCode} from "@/api/file/uploadF";
import {sendcode} from "@/api/user";
import {mapGetters, mapState} from "vuex";
import changshaRegion from "@/assets/changshaRegion";
import {getAccount} from "@/api/yhgl/account";
import {getTypes} from '@/api/finance/finance'
import moment from 'moment'
/* eslint-disable */

const columns = [
    {
      title: "省统一需求编码",
      dataIndex: "financingRequirementsCode",
      key: "financingRequirementsCode",
        width: 200,
        fixed: 'left'
    },
    {
        title: "申请日期",
        dataIndex: "createTime",
        width: 200,
        customRender: (val, row, index) => {
            return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        key: "createTime"
    },
    {
        title: "产品名称",
        key: "productName",
        width: 150,
        dataIndex: "productName"
    },
    {
        title: "申请金额（万元)",
        key: "commitAmout",
        width: 150,
        dataIndex: "commitAmout",
        scopedSlots: {customRender: "commitAmout"}
    },
    {
        title: "服务机构",
        key: "logindept",
        width: 250,
        dataIndex: "logindept"
    },
    {
        title: "授信日期",
        key: "loanTime",
        width: "9%",
        width: 200,
        dataIndex: "loanTime"
    },
    {
        title: "授信金额（万元)",
        key: "loanAmount",
        width: 150,
        dataIndex: "loanAmout",
        scopedSlots: {customRender: "loanAmout"}
    },
    {
        title: "利率(%)",
        key: "interestRate",
        width: 150,
        dataIndex: "interestRate",
        scopedSlots: {customRender: "interestRate"}
    },
    {
        title: "期限（月)",
        key: "deadline",
        width: 150,
        dataIndex: "deadline"
    },
    {
        title: "状态",
        dataIndex: "status",
        width: 100,
        fixed: 'right',
        scopedSlots: {customRender: "status"}
    },
    {
        title: "操作",
        width: 150,
        dataIndex: "operation",
        scopedSlots: {customRender: "operation"},
        fixed: 'right',
    }
];

const columnsOffer = [
    {
        title: "适配产品",
        key: "productName",
        dataIndex: "productName"
    },
    {
        title: "银行",
        dataIndex: "yname",
        key: "yname",
        scopedSlots: {customRender: "yname"}
    },
    {
        title: "授信金额（万元）",
        key: "fkje",
        dataIndex: "fkje",
        scopedSlots: {customRender: "fkje"}
    },
    {
        title: "授信利率",
        key: "fkl",
        dataIndex: "fkl"
    },
    {
        title: "担保",
        key: "guarantee",
        dataIndex: "guarantee",
        scopedSlots: {customRender: "guarantee"}
    },
    {
        title: "其他条件说明",
        key: "descriptionOfOtherConditions",
        dataIndex: "descriptionOfOtherConditions"
    },
    {
        title: "操作",
        dataIndex: "operation",
        scopedSlots: {customRender: "operation"}
    }
];
const stepList = [
    {
        title: '基础信息',
        status: 'finish',
        iconType: 'user'
    },
    {
        title: '融资期望',
        status: 'wait',
        iconType: 'money-collect'
    },
    {
        title: '企业信息',
        status: 'wait',
        iconType: 'team'
    },
];

export default {
    computed: {
        ...mapState(["downPath"]),
        ...mapGetters(["storeAccount"])
    },
    data() {
        return {
            current: 0,
            stepList,
            productOptions: [],
            taxList: [
                "0-2万（含）",
                "2-5万（含）",
                "5-10万（含）",
                "10万以上",
            ],
            businessIncomeList: [
                "0-100万（含）",
                "100-500万（含）",
                "500-1000万（含）",
                "1000万以上",
            ],
            taxGradeList: [
                "A",
                "B",
                "C",
                "D",
                "M",
                "个体工商户",
            ],
            chinesePrice: "",
            chinesePrice2: "",
            templateUrl: "",
            title: "",
            subbtnLoading: false,
            chinesePriceVisable: false,
            chinesePriceVisable2: false,
            modelState2: false,
            loading: false,
            imageUrl: "",
            spinning: false,
            deptNameShow: false,
            deptShow: false,
            productShow: false,
            columns,
            columnsOffer,
            changshaRegion,
            selectManagerName: [],
            formDirectional: this.$form.createForm(this),
            formDirectional2: this.$form.createForm(this),
            formSearch: this.$form.createForm(this),
            formSnatch: this.$form.createForm(this),
            form: this.$form.createForm(this),
            visible: false,
            visible2: false,
            hide: false,
            hide2: false,
            modelState: false,
            visibleDetails: false,
            authorization: "",
            dataSource: [],
            dataSourceOffer: [],
            regionMark: [],
            item: [],
            contactList: [],
            options: [],
            account: {},
            value: "",
            checked: "",
            qyName: "",
            name: "",
            proname: "",
            showItem: {},
            proname1: "",
            servebank: "",
            companyName: "",
            prointroduce: "",
            procharacter: "",
            applicationrequire: "",
            titleName: "",
            editContent: "",
            remarkinformation: "",
            subordinatebank: "",
            logindept: "",
            input2: "",
            timeStart: "",
            timeEnd: "",
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            paginationOffer: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            fileList: [
                {
                    // uid: "-1",
                    // name: "xxx.png",
                    // status: "done",
                    // url: ""
                }
            ],
            companyList: [],
            companyNames: [],
            industryList: [],
            uploadImgUrl: "",
            text: "",
            a: "a",
            b: "b",
            toggle: false,
            disabled: false,
            buttontext: "发送验证码",
            wait: 60,
            productId: "",
            company:{} ,
          financingRequirementsCode:"",
          operatorCode:"",
          showOperatorCode:false
        };
    },
    //列表显示
    beforeRouteEnter(to, from, next) {
        axios
            .all([
                myFinancing(1, "", ""),
                mySelect(),
                getListByCode("template_file", 1, 15)
            ])
            .then(res => {
                next(vm => {
                    // console.log(vm.$store.state.account)
                    if (res[0].data.success === "TRUE") {
                        vm.dataSource = res[0].data.data.page.list;
                        vm.pagination = {
                            current: res[0].data.data.page.pageNum,
                            pageSize: res[0].data.data.page.pageSize,
                            total: res[0].data.data.page.total
                        };
                    }
                    vm.getIndustry();
                    vm.options = res[1].data.data.page;
                    vm.company = res[1].data.data;
                    //vm.templateUrl = res[2].data.data.page.list[0].path;
                });
            })
            .catch(() => {
                next(vm => {
                    vm.$message.error("服务器出错！请稍后再试!");
                    vm.$Progress.fail();
                });
            });
    },
    methods: {
        //下一步
        nextStep() {
            let validateFields =
                this.current === 0 ? ["companyName", "area", "contact", "contactMobile", "industry", "isFirstUser"] :
                    this.current === 1 ? ["commitAmout", "interestRate", "deadline", "loanArrival","userId","yt"] :
                        this.current === 2 ? ["taxAmountOfLastYear", "profitOrLossStatus", "businessIncome", "taxGrade", "isCollateral", "bankOfDeposit", "currentLoanBalance", "previousLendingInstitutions"] : [];
            this.formDirectional2.validateFields(validateFields, (err, value) => {
                if (!err) {
                  let bool = null;
                  if (this.current === 1 && this.title=='融资（定向）') {
                    let accountId = this.$store.state.account.name;
                    findOnProId(accountId, this.productId)
                        .then(res => {
                          bool = res.data.data.result;
                          if (!bool) {
                            this.$message.warn("该产品存在进行中的订单，请勿重复申请！");
                          } else {
                            this.current++;
                            this.stepList[this.current].status = "finish";
                          }
                        })
                  } else {
                    this.current++;
                    this.stepList[this.current].status = "finish";
                  }
                }
            })
        },
        //上一步
        previousStep() {
            this.stepList[this.current].status = "wait";
            this.current--;
        },
        afterClose() {
            this.editContent = "";
            this.titleName = "";
            this.modelState2 = false;
        },
        //选择经办人触发
        managerNameChange(value) {
            for (let i = 0; i < this.contactList.length; i++) {
                if (this.contactList[i]['id'] == value) {
                    // this.formDirectional.setFieldsValue({
                    this.formDirectional2.setFieldsValue({
                        contact: this.contactList[i]['managerName'],
                        contactIdcard: this.contactList[i]['identificationNumber'],
                        contactMobile: this.contactList[i]['phone']
                    })
                    // this.formSnatch.setFieldsValue({
                    this.formSnatch.setFieldsValue({
                        contact: this.contactList[i]['managerName'],
                        contactIdcard: this.contactList[i]['identificationNumber'],
                        contactMobile: this.contactList[i]['phone']
                    })
                }
            }
        },
        handleCompanyChange(value) {
            for (let i = 0; i < this.companyList.length; i++) {
                if (this.companyList[i]["companyName"] == value) {
                    this.formDirectional.setFieldsValue({
                        socialCreditUnicode:
                            this.companyList[i]["socialCreditUnicode"]
                    });
                    this.formDirectional.setFieldsValue({
                        frdb: this.companyList[i]["frdb"]
                    });
                    this.formDirectional.setFieldsValue({
                        companyId: this.companyList[i]["companyId"]
                    });
                }
            }
        },
        //对选项进行搜索
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getIndustry() {
            getTypes("003008")
                .then(res => {
                    if (res.data.success == "TRUE") {
                        this.industryList = res.data.data.list;
                    }
                }).catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
            });
        },
        handleCompanyChange2(value) {
            for (let i = 0; i < this.companyList.length; i++) {
                if (this.companyList[i]["companyName"] == value) {
                    this.formSnatch.setFieldsValue({
                        socialCreditUnicode:
                            this.companyList[i]["socialCreditUnicode"]
                    });
                    this.formSnatch.setFieldsValue({
                        frdb: this.companyList[i]["frdb"]
                    });
                    this.formSnatch.setFieldsValue({
                        companyId: this.companyList[i]["companyId"]
                    });
                }
            }
        },

        transform(el) {
            //设置只能输入5位整数和2位小数
            let reg = /^\d{1,5}(\.\d{1,2})?$/;
            let val = el.target.value.replace(",", "");
            let target = el.target;
            target.oninput = () => {
                target.value = target.value.replace(",", "");
                //清除非 数字和小数点的字符
                target.value = target.value.replace(/[^\d.]/g, "")
                //清除第二个小数点
                target.value = target.value.replace(/\.{2,}/g, ".")
                //验证第一个字符是数字而不是字符
                target.value = target.value.replace(/^\./g, "");
                target.value = target.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                //保留两位小数
                target.value = target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
                //限制只能输入5位正整数
                target.value = target.value.indexOf(".") > 0 ? target.value.split(".")[0].substring(0, 5) + "." + target.value.split(".")[1] : target.value.substring(0, 5);
            }
            if (val == "") {
                this.chinesePriceVisable = false;
                this.chinesePrice = undefined;
                return;
            }
            if (reg.test(val)) {
                let Dnum = val;
                // let Dnum = this.formDirectional.getFieldsValue().commitAmout;
                let intNum = Dnum.toString().replace(/,/g, "").split(".");
                let strIntNum = intNum[0];
                let strDecNum = intNum[1];
                let count = 0;
                let result = [];
                for (let i = strIntNum.length - 1; i >= 0; i--) {
                    count++;
                    result.unshift(strIntNum[i]);
                    if (!(count % 3) && i != 0) {
                        result.unshift(",");
                    }
                }
                result = result.join("");
                if (intNum.length > 1) {
                    strDecNum = intNum[1];
                    result = result + "." + strDecNum;
                }

                this.formDirectional2.setFieldsValue({
                    commitAmout: result
                });

                this.chinesePrice = numberToChines(Dnum);
                // this.chinesePrice = priceToChinese(Dnum);
                this.chinesePriceVisable = true;
            }
        },
        transform2(el) {
            //设置只能输入5位整数和2位小数
            let reg = /^\d{1,5}(\.\d{1,2})?$/;
            let val = el.target.value.replace(",", "");
            let target = el.target;
            target.oninput = () => {
                target.value = target.value.replace(",", "");
                //清除非 数字和小数点的字符
                target.value = target.value.replace(/[^\d.]/g, "")
                //清除第二个小数点
                target.value = target.value.replace(/\.{2,}/g, ".")
                //验证第一个字符是数字而不是字符
                target.value = target.value.replace(/^\./g, "");
                target.value = target.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                //保留两位小数
                target.value = target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
                //限制只能输入5位正整数
                target.value = target.value.indexOf(".") > 0 ? target.value.split(".")[0].substring(0, 5) + "." + target.value.split(".")[1] : target.value.substring(0, 5);
            }
            if (val == "") {
                this.chinesePriceVisable2 = false;
                return;
            }
            if (reg.test(val)) {
                let Dnum = val;
                // let Dnum = this.formDirectional.getFieldsValue().commitAmout;
                let intNum = Dnum.toString().replace(/,/g, "").split(".");
                let strIntNum = intNum[0];
                let strDecNum = intNum[1];
                let count = 0;
                let result = [];
                for (let i = strIntNum.length - 1; i >= 0; i--) {
                    count++;
                    result.unshift(strIntNum[i]);
                    if (!(count % 3) && i != 0) {
                        result.unshift(",");
                    }
                }
                result = result.join("");
                if (intNum.length > 1) {
                    strDecNum = intNum[1];
                    result = result + "." + strDecNum;
                }

                this.formDirectional2.setFieldsValue({
                    currentLoanBalance: result
                });

                this.chinesePrice2 = numberToChines(Dnum);
                // this.chinesePrice = priceToChinese(Dnum);
                this.chinesePriceVisable2 = true;
            }
        },
        transform1() {
            let Dnum = this.formSnatch.getFieldsValue().commitAmout;
            if (Dnum == "") {
                this.chinesePriceVisable = false;
                return;
            }
            let intNum = Dnum.toString().replace(/,/g, "").split(".");
            let strIntNum = intNum[0];
            let strDecNum = intNum[1];
            let count = 0;
            let result = [];
            for (let i = strIntNum.length - 1; i >= 0; i--) {
                count++;
                result.unshift(strIntNum[i]);
                if (!(count % 3) && i != 0) {
                    result.unshift(",");
                }
            }
            result = result.join("");
            if (intNum.length > 1) {
                strDecNum = intNum[1];
                result = result + "." + strDecNum;
            }

            this.formSnatch.setFieldsValue({
                commitAmout: result
            });
            this.chinesePrice = priceToChinese(Dnum);
            this.chinesePriceVisable = true;
        },
        showOffersDetail(data) {
            this.visibleDetails = true;
            this.showItem = data;
            this.showItem.industry = data.industry == null ? "" : this.industryList.find(item => item.param == data.industry).desc;
            if (data.yxdwUserId != null) {
                getAccount(data.yxdwUserId).then(res => {
                    if (res.data.success === "TRUE") {
                        this.account = res.data.data.account;
                    }
                })
            }
        },
        onCloseDetails() {
            this.visibleDetails = false;
            this.showItem = {};
            this.account = {};
        },
        onClose() {
            this.formDirectional2.resetFields();
            this.formDirectional.resetFields();
            this.regionMark = [];
            this.visible = false
            this.uploadImgUrl = ""
            this.chinesePrice = ""
            this.imageUrl = ""
            this.chinesePriceVisable = false;
            this.chinesePriceVisable2 = false;
            this.deptNameShow = false;
            this.deptShow = false;
            this.productShow = false;
            this.current = 0;
            this.stepList[1].status = "wait";
            this.stepList[2].status = "wait";
          this.financingRequirementsCode="";
          this.operatorCode="";
          this.showOperatorCode = false;
        },
        onClose2() {
            this.formSnatch.resetFields();
            this.visible2 = false
            this.uploadImgUrl = ""
            this.imageUrl = "";
            this.deptNameShow = false;
            this.deptShow = false;
            this.productShow = false;
        },
        handleOk() {
            this.hide = false;

        },
        handleOk2() {
            this.hide2 = false;
        },
        //我要融资（定向）
        financingDirectional() {
            this.changshaRegion.map(item => {
                item.label = item.name
                item.value = item.name
                item.children.map(res => {
                    res.label = res.name;
                    res.value = res.name;
                    res.children.map(resp => {
                        resp.label = resp.name;
                        resp.value = resp.name;
                    })
                })
            })

            this.title = "融资（定向）";
            this.visible = true;
            // this.visible2 = false;
            this.deptNameShow = true;
            this.deptShow = true;
            this.productShow = true;
            this.chinesePrice = "";


                    getManagerLists().then(resp => {
                        this.contactList = resp.data.data.list;
                        // this.formDirectional.setFieldsValue({
                        this.formDirectional2.setFieldsValue({
                          companyName: this.company.qyname,
                          socialCreditUnicode: this.company.uscc,
                          companyId: this.company.companyId,
                          frdb: this.company.frdb,
                          address: this.company.address,
                            contactIdcard: this.contactList[0]['identificationNumber'],
                            contact: this.contactList[0]['managerName'],
                            contactMobile: this.contactList[0]['phone'].toString(),
                        })
                    })

        },
        //我要融资（抢单）
        financingSnatch() {
            this.changshaRegion.map(item => {
                item.label = item.name
                item.value = item.name
                item.children.map(res => {
                    res.label = res.name;
                    res.value = res.name;
                    res.children.map(resp => {
                        resp.label = resp.name;
                        resp.value = resp.name;
                    })
                })
            })
            this.title = "融资（抢单）";
            // this.visible2 = true;
            this.visible = true;
            this.deptNameShow = false;
            this.deptShow = false;
            this.productShow = false;
          getRecommended().then(resp => {
            this.productOptions = resp.data.data.page;

          })

                    this.qyName = this.company.qyname;
                     getManagerLists().then(resp => {
                         this.contactList = resp.data.data.list;
                         this.formDirectional2.setFieldsValue({
                           companyName: this.company.qyname,
                           socialCreditUnicode: this.company.uscc,
                           companyId: this.company.companyId,
                           frdb: this.company.frdb,
                           address: this.company.address,
                             contactIdcard: this.contactList[0]['identificationNumber'],
                             contact: this.contactList[0]['managerName'],
                             contactMobile: this.contactList[0]['phone'].toString(),
                         })
                     })

        },
        //分页切换
        change(page) {
            this.pagination.current = page.current;
            this.initList();
            this.spinning = false;
        },
        change2(page) {
            this.pagination.current = page.current;
            this.initList();
            this.spinning = false;
        },
        initList() {
            this.spinning = true;
            myFinancing(
                this.pagination.current,
                this.proname1,
                this.servebank,
                this.timeStart,
                this.timeEnd
            ).then(res => {
                if (res.data.success === "TRUE") {
                    this.spinning = false;
                    this.dataSource = res.data.data.page.list;
                    this.pagination = {
                        current: res.data.data.page.pageNum,
                        pageSize: res.data.data.page.pageSize,
                        total: res.data.data.page.total
                    };
                }
            });
        },
        //下拉选择
        handleSelectChange(value, option) {
            this.hide = true;
            this.gender = option.key;
            this.productId = value;
            mySelectmes(value).then(res => {
                if (res.data.success === "TRUE") {
                    this.spinning = false;
                    this.showItem = res.data.data.page;
                    /*let regionId=res.data.data.page.regionId.split("|");
                    let region=res.data.data.page.region.split("|");
                  for(let i=0;i<regionId.length;i++){
                        this.regionMark.push({"regionId":regionId[i],"regionName":region[i]});
                  }*/
                    this.getFzjg(res.data.data.page.logindeptid, res.data.data.page.regionId);
                    // this.formDirectional.setFieldsValue({
                    this.formDirectional2.setFieldsValue({
                        logindept: res.data.data.page.logindept,
                        /*area: this.storeAccount.area*/
                    });

                    this.logindept = res.data.data.page.logindept;
                    this.indexId = res.data.data.page.indexId;
                    this.name = res.data.data.page.name;
                }
            });
        },
        getFzjg(yxdwId, area) {
            getFzjg(yxdwId, area).then(res => {
                if (res.data.success === "TRUE") {
                    this.regionMark = res.data.data.fzjg;
                    this.regionMark.forEach(it => {
                        if (it.area.indexOf(this.storeAccount.area) > -1) {
                            this.formDirectional.setFieldsValue({
                                userId: it.id
                            });
                        }
                    })
                }
            })
        },
        //上传按钮
        handleChange(info) {
            if (info.file.status === "done") {
                this.$message.success(`${info.file.name} 上传成功`);
            } else if (info.file.status === "error") {
                this.$message.error(`${info.file.name} 上传失败.`);
            }
        },
        beforeUpload(file) {
            const isJPG =
                file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "image/gif";
            if (!isJPG) {
                this.$message.error("你只能上传图片!");
                return false;
            }
            const isLt300k = file.size / 1024;
            if (isLt300k > 300) {
                this.$message.error("图片只能小于300k!");
                return false;
            }
            return isJPG && isLt300k;
        },
        customRequest(files) {
            this.text = files.text;
            let formData = new FormData();
            formData.append("file", files.file);

            uoloadFilesq(formData)
                .then((res) => {
                    if (res.data.success === "TRUE") {
                        this.uploadImgUrl = res.data.data.sqtys;
                        this.$message.success("图片上传成功!");
                        this.imageUrl = this.uploadImgUrl;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("上传错误，请重新上传");
                });
        },
        //定向&抢单确认
        directionalConfirm() {
            /*if (this.title == "融资（定向）") {
                this.formDirectional.validateFields((err, values) => {
                    // console.log(err)
                    if (!err) {
                        values.status = 0;
                        values.proid = values.gender;
                        values.sqtys = this.uploadImgUrl;
                        values.commitAmout = values.commitAmout
                            .toString()
                            .replace(/,/g, "");
                        if (this.toggle) {
                            values.agree = 1;
                            // console.log(values)
                            this.subbtnLoading = true;
                            addFinancing(values)
                                .then((res) => {
                                    this.subbtnLoading = false;
                                    if (res.data.success === "TRUE") {
                                        this.proname1 = "";
                                        this.servebank = "";
                                        this.onClose();
                                        this.initList();
                                        this.$message.success("融资提交成功");
                                    } else {
                                        this.$message.error(res.data.message);
                                    }
                                })
                                .catch(() => {
                                    this.subbtnLoading = false;
                                    this.$message.error("融资提交失败，请重试");
                                });
                        } else {
                            this.$message.error("请选择同意用信单位查看信用报告");
                        }
                    }
                });
            } else {*/
                this.formDirectional2.validateFields(
                    /*[
                        'companyName',
                        'socialCreditUnicode',
                        'frdb',
                        'address',
                        'commitAmout',
                        'deadline',
                        'contact',
                        'contactIdcard',
                        'contactMobile',
                        'code'
                    ], */(err, values) => {
                        if (!err) {
                            values.socialCreditUnicode = this.$store.state.account.idCard;
                            values.interestRate = this.title.includes("融资（定向）")  ?'':parseFloat(values.interestRate);
                            values.loanArrival = parseInt(values.loanArrival);
                            values.area = values.area.join("/"),
                                values.status = this.title.includes("融资（定向）")  ? 0 : 1;
                            values.proid = this.title.includes("融资（定向）")  ? values.gender : 0;
                            values.sqtys = this.uploadImgUrl;
                            values.commitAmout = values.commitAmout
                                .toString()
                                .replace(/,/g, "");
                            if(values.currentLoanBalance) {
                              values.currentLoanBalance = values.currentLoanBalance
                                  .toString()
                                  .replace(/,/g, "");
                            }
                            const formJson = {
                                companyId: values.companyId,
                                commitAmout: values.commitAmout,
                                productName: values.productName

                            };
                            // TODO 金融机构的订单查看“信用报告”需要增加自主申报（订单的企业信息模块）功能， 功能单独判断进行添加
                            /*if(this.uploadImgUrl!=null&&this.uploadImgUrl!="") {*/
                            if (this.toggle) {
                                values.agree = 1;
                                this.subbtnLoading = true;
                              if (this.financingRequirementsCode == "") {
                                 financingRequirementsCode(values).then((res) => {
                                  if (res.data.success) {
                                    this.financingRequirementsCode = res.data.financingRequirementsCode;
                                    this.title = this.title+"，省统一需求编码："+this.financingRequirementsCode;
                                    if(res.data.isCheck==1){
                                      this.showOperatorCode=true;
                                      this.subbtnLoading = false;
                                      return false;
                                    }else{
                                      values.financingRequirementsCode = this.financingRequirementsCode;
                                      values.operatorCode=this.operatorCode;
                                      this.dosave(values);
                                    }
                                  }else {
                                    this.subbtnLoading = false;
                                  }
                                }).catch(() => {
                                  this.subbtnLoading = false;
                                  this.$message.error("获取统一需求编码失败，请重试");
                                });
                              }else{
                                values.financingRequirementsCode = this.financingRequirementsCode;
                                values.operatorCode=this.operatorCode;
                                this.dosave(values);
                              }

                            } else {
                                this.subbtnLoading = false;
                                this.$message.error("请选择同意用信单位查看信用报告");
                            }
                        }
                    })
            // }

        },
      dosave(values){
        addFinancing(values).then((res) => {
          this.subbtnLoading = false;
          if (res.data.success === "TRUE") {
            this.proname1 = "";
            this.servebank = "";
            this.onClose();
            this.initList();
            this.$message.success("融资提交成功");
          } else {
            this.$message.error(res.data.message);
          }
        })
            .catch(() => {
              this.subbtnLoading = false;
              this.$message.error("融资提交失败，请重试");
            });
      },
        //抢单确认
        snatchConfirm() {
            this.formSnatch.validateFields((err, values) => {
                if (!err) {
                    // console.log(values);
                    values.status = 1;
                    values.proid = 0;
                    values.sqtys = this.uploadImgUrl;
                    values.commitAmout = values.commitAmout
                        .toString()
                        .replace(/,/g, "");
                    const formJson = {
                        companyId: values.companyId,
                        commitAmout: values.commitAmout,
                        productName: values.productName

                    };
                    /*if(this.uploadImgUrl!=null&&this.uploadImgUrl!="") {*/
                    if (this.toggle) {
                        values.agree = 1;
                        addFinancing(values)
                            .then((res) => {
                                if (res.data.success === "TRUE") {
                                    this.proname1 = "";
                                    this.servebank = "";
                                    this.onClose2();
                                    this.initList();
                                    this.$message.success("融资提交成功");
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            })
                            .catch(() => {
                                this.$message.error("融资提交失败，请重试");
                            });
                    } else {
                        this.$message.error("请选择同意用信单位查看信用报告");
                    }
                    /* }else {
                            this.$message.error("未上传授权同意书")
                        }*/
                }
            });
        },
        searchConfirm() {
            this.formSearch.validateFields((err, values) => {
                if (!err) {
                    var proname = "";
                    var servebank = "";
                    if (values.proname1 != null) {
                        proname = values.proname1;
                        this.proname1 = values.proname1;
                    } else {
                        proname = "";
                        this.proname1 = "";
                    }
                    if (values.servebank != null) {
                        servebank = values.servebank;
                        this.servebank = values.servebank;
                    } else {
                        servebank = "";
                        this.servebank = "";
                    }
                  this.timeStart= values["times"] ? this.formatDate(values["times"][0]["_d"], true) : "";
                      this.timeEnd= values["times"] ? this.formatDate(values["times"][1]["_d"],true,"end") : "";
                    myFinancing(1, proname, servebank,this.timeStart,this.timeEnd)
                        .then((res) => {
                            if (res.data.success === "TRUE") {
                                this.dataSource = res.data.data.page.list;
                                this.pagination = {
                                    current: res.data.data.page.pageNum,
                                    pageSize: res.data.data.page.pageSize,
                                    total: res.data.data.page.total
                                };
                            }
                        })
                        .catch(() => {
                            this.$message.error("查询失败，请重试");
                        });
                }
            });
        },
        backConfirm() {
            this.formSearch.resetFields();
            this.proname1 = "";
            this.servebank = "";
            this.timeStart ="";
            this.timeEnd = "";
            this.initList();
        },
        //表单验证
        validateCode(rule, value, callback) {
            let reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;
            if (value && !reg.test(value)) {
                callback("请填写正确的统一社会信用代码");
            } else {
                callback();
            }
        },
        validatePhone(rule, value, callback) {
            let reg = /^1[3456789]\d{9}$/;
            if (value && !reg.test(value)) {
                callback("请填写正确的手机号码");
            } else {
                callback();
            }
        },
        validateData(rule, value, callback) {
            let reg = /^\d+(\.\d+)?$/;
            if (value && !reg.test(value)) {
                callback("请填写数字");
            } else {
                callback();
            }
        },
        showOffers(data) {
            offerList(data.id)
                .then((res) => {
                    if (res.data.success === "TRUE") {
                        this.spinning = false;
                        this.dataSourceOffer = res.data.data.page.list;
                        this.paginationOffer = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                        this.companyName = data.companyName;
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch(() => {
                    this.$message.error("查看报价失败，请重试");
                });
            this.hide2 = true;
        },
        getOffers(data) {
            getOffer(data, this.companyName)
                .then(res => {
                    if (res.data.success === "TRUE") {
                        this.$message.success("成功提交贷款申请！");
                        this.initList();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch(() => {
                    this.$message.error("提交贷款申请失败，请重试");
                });
            this.hide2 = false;
        },
        cancelOffer() {
            console.log("取消");
        },
        replace1() {
            console.log(this.input2);
        },
        down() {
            let aTag = document.createElement('a');
            aTag.download = "授权书模板.doc";
            aTag.href = this.$store.state.downPath2;
            aTag.click();
        },
        down2() {
            this.modelState2 = true;
            getEnablePowerOfAttorney().then(resp => {
                this.titleName = resp.data.data.result.title;
                this.editContent = resp.data.data.result.content;
            })
            // getSqtys()
            //     .then(res => {
            //       this.authorization=res.data.data.authorization;
            //       this.modelState=true;
            //     })
            //     .catch(() => {
            //       this.$message.error("服务器出错！请稍后再试!");
            //     });
        },
        sendcode(type) {
            let userName = null
            if (type == 1) {
                userName = this.formDirectional.getFieldValue("contactMobile");
            } else {
                userName = this.formSnatch.getFieldValue("contactMobile");
            }
            if (userName) {
                sendcode(userName)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.time();
                        });
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            } else {
                this.$message.error("请输入经办人手机号!");
            }


        },
      listClick(id){
        //this.$router.push({ name: "financeProduct_detail", query: {id: id} });
        const {href} = this.$router.resolve({
          name: "financeProduct_detail", query: {id: id}
        });
        window.open(href, '_blank');
      },
      formatDate(dates, type, time) {
        let date = {
              year: dates.getFullYear(),
              month:
                  dates.getMonth() + 1 < 10
                      ? "0" + (dates.getMonth() + 1)
                      : dates.getMonth() + 1,
              day:
                  dates.getDate() < 10
                      ? "0" + dates.getDate()
                      : dates.getDate(),
              hour:
                  dates.getHours() < 10
                      ? "0" + dates.getHours()
                      : dates.getHours(),
              minute:
                  dates.getMinutes() < 10
                      ? "0" + dates.getMinutes()
                      : dates.getMinutes(),
              second:
                  dates.getSeconds() < 10
                      ? "0" + dates.getSeconds()
                      : dates.getSeconds()
            },
            times = "00:00:00";
        if (type) {
          if (time) {
            times = "23:59:59";
          }
          return (
              date.year + "-" + date.month + "-" + date.day + " " + times
          );
        } else {
          return (
              date.year +
              "-" +
              date.month +
              "-" +
              date.day +
              " " +
              date.hour +
              ":" +
              date.minute +
              ":" +
              date.second
          );
        }
      },
        time() {
            if (this.wait == 0) {
                this.disabled = false;
                this.buttontext = "获取验证码";
                this.wait = 60;
            } else {
                this.disabled = true;
                this.buttontext = "重新发送(" + this.wait + ")";
                this.wait--;
                setTimeout(() => {
                    this.time()
                }, 1000)
            }
        }
    },

    mounted() {
        getCompanyList().then((res) => {
            this.companyList = res.data.data.companyList;
            for (let i = 0; i < this.companyList.length; i++) {
                this.companyNames.push(this.companyList[i]["companyName"]);
            }
        });
    },

};
</script>


<style scoped lang="less">
    .ant-btn {
        font-size: 12px;
    }

    .ant-table-wrapper {
        font-size: 12px;
        margin-top: 20px;
    }

    .ant-table-row > td {
        font-size: 12px;
    }

    .spin-content {
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        padding: 30px;
    }

    .cmm-wrapper {
        white-space: pre-wrap;
    }

    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 169px;
        }
    }

    .btns-group button {
        margin-right: 10px;
        margin-top: 24px;
    }

    /deep/ .ant-descriptions-item-label {
        width: 20%;
    }
</style>
